<template>
  <div
    class="fixed z-10 inset-0 overflow-y-auto"
    aria-labelledby="modal-title"
    role="dialog"
    aria-modal="true"
  >
    <div class="flex items-center justify-center text-center sm:p-5">
      <div
        class="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity"
        aria-hidden="true"
      ></div>
      <span
        class="hidden sm:inline-block sm:align-middle sm:h-screen"
        aria-hidden="true"
      >&#8203;</span
      >
      <div
        class="align-middle mt-24 bg-white rounded-lg text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:max-w-lg w-full mx-3"
      >
        <div class="bg-white px-4 pt-5 pb-4 sm:p-6 sm:pb-4">
          <div class="w-full">
            <div>
              <div class="flex items-center justify-between">
                <h1 class="text-lg font-semibold">Details</h1>
                <button
                  @click="$emit('close')"
                  type="button"
                  class="rounded-md bg-white text-gray-400 hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2"
                >
                  <span class="sr-only">Close</span>
                  <svg
                    class="h-6 w-6"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke-width="1.5"
                    stroke="currentColor"
                    aria-hidden="true"
                  >
                    <path
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      d="M6 18L18 6M6 6l12 12"
                    />
                  </svg>
                </button>
              </div>
              <div class="mt-4">
                <label
                  for="firstname"
                  class="block text-sm font-medium leading-6 text-gray-900"
                >First Name</label
                >
                <div class="mt-2">
                  <input
                    type="text"
                    v-model="first_name"
                    name="first-name"
                    class="input"
                    placeholder="Enter first name"
                  />
                </div>
              </div>
              <div class="mt-4">
                <label
                  for="lastname"
                  class="block text-sm font-medium leading-6 text-gray-900"
                >Last Name</label
                >
                <div class="mt-2">
                  <input
                    type="text"
                    v-model="last_name"
                    name="last-name"
                    class="input"
                    placeholder="Enter last name"
                  />
                </div>
              </div>
              <div class="mt-4">
                <label
                  for="email"
                  class="block text-sm font-medium leading-6 text-gray-900"
                >Email Address</label
                >
                <div class="mt-2">
                  <input
                    type="email"
                    v-model="email"
                    name="email"
                    class="input"
                    placeholder="Enter email"
                  />
                </div>
              </div>
              <div class="mt-4">
                <label
                    for="phone-number"
                    class="block text-sm font-medium leading-6 text-gray-900"
                >Phone Number</label
                >
                <div class="mt-2">
                  <input
                      type="tel"
                      v-model="phone"
                      name="phone-number"
                      class="input"
                      placeholder="+1 (123) 456-7890"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="bg-gray-50 px-4 py-3 sm:px-6 sm:flex sm:flex-row-reverse">
          <button
            type="button"
            class="btn-modal-submit"
            @click="buyFreeProduct"
          >
            {{ loading ? 'Loading...' : 'Submit' }}
          </button>
          <button
            type="button"
            class="btn-modal-cancel"
            @click="$emit('close')"
          >
            Cancel
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import ApiUrls from '../../api-url';
import AuthenticationMixin from '../../authentication-mixin';

export default {
  mixins: [ApiUrls, AuthenticationMixin],
  props: {
    orgId: {
      type: Number,
      required: true,
    },
    productId: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      first_name: '',
      last_name: '',
      email: '',
      phone: '',
    };
  },
  methods: {
    isValid() {
      const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      const phonePattern = /^\+?[0-9()\-\s]{7,20}$/;
      const fields = [
        { value: this.first_name, message: 'First name is required.' },
        { value: this.last_name, message: 'Last name is required.' },
        { value: this.email, message: 'Email is required.' },
        { value: this.phone, message: 'Phone number is required.' },
      ];
      for (const field of fields) {
        if (!field.value) {
          this.$toast.show(field.message, this.toasted_options.error);
          return false;
        }
      }
      if (!emailPattern.test(this.email)) {
        this.$toast.show('Invalid email format.', this.toasted_options.error);
        return false;
      }
      if (!phonePattern.test(this.phone)) {
        this.$toast.show('Invalid phone number format.', this.toasted_options.error);
        return false;
      }
      return true;
    },
    async buyFreeProduct() {
      if (this.isValid()) {
        let body = {
          first_name: this.first_name,
          last_name: this.last_name,
          email: this.email,
          phone: this.phone,
          organization_id: this.orgId,
          product_id: this.productId,
          time_zone: Intl.DateTimeFormat().resolvedOptions().timeZone,
        };
        this.loading = true;
        const response = await this.axiosInstance.post(
          this.stripeUrl + 'buy_free_product',
          body,
        );
        if (response.data.success) {
          window.location.href = response.data.result.url;
        }
        this.loading = false;
      }
    },
  },
};
</script>
